module.exports = function (shopLocatorService, breakpointsService) {
    return {
        restrict: 'E',
        scope: true,
        link(scope) {

            const _breakpointsService = breakpointsService;

            scope.isSmallFormat = _breakpointsService.isInSmallFormat;

            scope.$on('window:resize', function () {
                scope.$apply(function () {
                    scope.isSmallFormat = _breakpointsService.isSmallFormat();
                });
            });

            scope.shopLocatorService = shopLocatorService;

            scope.$on('$destroy', function () {
                shopLocatorService.selectedStore = undefined;
            });
        },
        template: require('./shop-details-panel-template.html').trim()
    };
}
;



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/shoplocator/storedetails/shop-details-panel-directive.js
 **/